import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
import { AppInfo } from 'utils/AppInfo';
import { Environment } from 'utils/EnvironmentHelper';

const history = createBrowserHistory();

const debugMode = new URL(window.location.href).searchParams.has('sentryDebugLogging');
function log(...params: unknown[]) {
    if (debugMode) {
        // eslint-disable-next-line no-console
        console.log(...params);
    }
}
log('dsn', Environment.sentryUrl);
log('env', Environment.kcfEnv + (Environment.isLocalDevelopment ? '-local' : ''));
log('isSentryEnabled', Environment.isSentryEnabled);

Sentry.init({
    dsn: Environment.sentryUrl,
    environment: Environment.kcfEnv + (Environment.isLocalDevelopment ? '-local' : ''),
    release: AppInfo.displayVersion(),
    integrations: [
        Sentry.breadcrumbsIntegration(),
        Sentry.browserApiErrorsIntegration(),
        Sentry.browserSessionIntegration(),
        Sentry.dedupeIntegration(),
        Sentry.functionToStringIntegration(),
        Sentry.globalHandlersIntegration({
            onerror: true,
            onunhandledrejection: true,
        }),
        Sentry.httpContextIntegration(),
        // Sentry.eventFiltersIntegration(),
        Sentry.linkedErrorsIntegration(),

        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    ],
    enabled: Environment.isSentryEnabled,

    sampleRate: 1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    debug: debugMode,
});

if (debugMode) {
    Sentry.logger.info('sentry initialized with debug logging');
}
